import { PacketLabelApiService } from '../../common/services/packet-label.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,

  state: {
    item: {},
    status: '',
  },

  getters: {
    getItem: state => state.item,
    getStatus: state => state.status,
  },

  mutations: {
    SET_ITEM(state, data) {
      state.item = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    postPacketLabel({ commit, dispatch }, { formData }) {
      commit('FETCH_REQUEST');

      return PacketLabelApiService.post(formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response);
        })
        .catch(error => {
          dispatch('handleError', error);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      if (message) {
        this.$app.$alertError(message);
      }
    },
  },
};
